import React, { useState } from 'react';
import PropTypes from 'prop-types';
import ReactModal from 'react-modal';
import DesktopAndTabletContainerFull from '../../shared/DesktopAndTabletContainerFullWidth';
import MobileContainerFull from '../../shared/MobileContainerFullWidth';
import ConditionalWrapper from '../../shared/conditionalWrapper/ConditionalWrapper';
import VideoModal from '../shared/VideoModal';
import LazyLoadImg from '../shared/LazyLoadImg';

const IconText30By70ContentComponent = ({ iconTextItems }) => {
  const [selectedContentGuid, selectContent] = useState(null);

  const setSelectedContent = guid => {
    if (guid === selectedContentGuid) {
      selectContent(null);
    } else {
      selectContent(guid);
    }
  };

  const selectedContent =
    iconTextItems && iconTextItems.find(item => item.guid === selectedContentGuid);

  ReactModal.setAppElement('#wrapper');

  return (
    <section className="section-white">
      <div className="container-fluid">
        {iconTextItems.map(item => (
          <div className="section-gutter-half" key={item.guid}>
            <ConditionalWrapper>
              <div className={`section-icon-text ${item.textPosition}`} key={item.guid}>
                <div className="content">
                  <div dangerouslySetInnerHTML={{ __html: item.description }} />
                </div>

                <div className="media">
                  <ConditionalWrapper>
                    {item.image && item.image.url && (
                      <ConditionalWrapper
                        condition={item.imageUrl}
                        wrapper={children => (
                          <a
                            href={item.imageUrl}
                            target={item.imageUrlTarget}
                            title={`Link for ${item.altText || item.title}`}
                          >
                            {children}
                          </a>
                        )}
                      >
                        {item.imageMobile && item.imageMobile.url ? (
                          <>
                            <MobileContainerFull>
                              <LazyLoadImg src={item.imageMobile} alt={item.altText} />
                            </MobileContainerFull>
                            <DesktopAndTabletContainerFull>
                              <LazyLoadImg src={item.image} alt={item.altText} />
                            </DesktopAndTabletContainerFull>
                          </>
                        ) : (
                          <LazyLoadImg src={item.image} alt={item.altText} />
                        )}
                      </ConditionalWrapper>
                    )}
                  </ConditionalWrapper>
                </div>
              </div>
            </ConditionalWrapper>
          </div>
        ))}
        <VideoModal
          {...selectedContent}
          selectFunction={setSelectedContent}
          isActive={!!selectedContentGuid}
        />
      </div>
    </section>
  );
};

IconText30By70ContentComponent.defaultProps = {
  iconTextItems: []
};

IconText30By70ContentComponent.propTypes = {
  iconTextItems: PropTypes.arrayOf(PropTypes.object)
};

export default IconText30By70ContentComponent;
